"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useItemContext = exports.ItemProvider = void 0;
var _react = require("react");
const context = /*#__PURE__*/(0, _react.createContext)({
  bp: '0',
  code: '0',
  isAvailable: false,
  isBundle: false,
  isBundleItem: false,
  itemTestId: 'Checkout-checkout-basket-item',
  lineNumber: 0,
  maxQuantity: 0,
  name: 'item',
  priceName: 'regularPrice',
  quantity: 0,
  testId: 'test',
  totalPrice: '0',
  type: null,
  url: '/products/product?code=0'
});
const ItemProvider = exports.ItemProvider = context.Provider;
const useItemContext = () => (0, _react.useContext)(context);
exports.useItemContext = useItemContext;
